window.dataLayer = window.dataLayer || [];

window.FreshGTM = (function () {
  var STORAGE_KEY = 'fresh_gtm_item_list';

  /**
   * Parses product.type into GA4 category fields.
   * e.g. "ŞAL > Düz Şal > KRİNKIL MEDİNE İPEĞİ ŞAL"
   *   => { item_category: "ŞAL", item_category2: "Düz Şal", item_category3: "KRİNKIL MEDİNE İPEĞİ ŞAL" }
   * Max 4 levels: item_category, item_category2, item_category3, item_category4
   */
  function parseCategories(productType) {
    if (!productType) return {};
    var parts = productType.split(' > ').map(function (s) { return s.trim(); }).filter(Boolean);
    var keys = ['item_category', 'item_category2', 'item_category3', 'item_category4'];
    var result = {};
    parts.slice(0, 4).forEach(function (part, i) {
      result[keys[i]] = part;
    });
    return result;
  }

  /**
   * Store the item list context (list_id + list_name) for a product in localStorage.
   * Keyed by product ID so all subsequent events can retrieve it.
   */
  function setItemListContext(productId, listId, listName) {
    try {
      var store = JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}');
      store[String(productId)] = { item_list_id: listId, item_list_name: listName };
      localStorage.setItem(STORAGE_KEY, JSON.stringify(store));
    } catch (e) {}
  }

  /**
   * Retrieve stored item list context for a product.
   * Returns { item_list_id, item_list_name } or null.
   */
  function getItemListContext(productId) {
    try {
      var store = JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}');
      return store[String(productId)] || null;
    } catch (e) {
      return null;
    }
  }

  /**
   * Push a GA4 ecommerce event to dataLayer.
   * Always clears ecommerce first per GA4 spec.
   */
  function pushEvent(eventData) {
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push(eventData);
  }

  return {
    parseCategories: parseCategories,
    setItemListContext: setItemListContext,
    getItemListContext: getItemListContext,
    pushEvent: pushEvent
  };
})();

// ─── add_to_cart: fetch interceptor for /cart/add.js ─────────────────────────
(function () {
  var _fetch = window.fetch;
  window.fetch = function () {
    var args = Array.prototype.slice.call(arguments);
    var url = args[0];
    var options = args[1] || {};
    var urlStr = (typeof url === 'string') ? url : (url && url.url ? url.url : '');

    var isCartAdd = urlStr && /\/cart\/add(\.js)?(\?|$)/.test(urlStr) && (options.method || 'GET').toUpperCase() === 'POST';

    if (!isCartAdd) {
      return _fetch.apply(window, args);
    }

    return _fetch.apply(window, args).then(function (response) {
      var cloned = response.clone();
      cloned.json().then(function (data) {
        try {
          // Shopify returns either a single item object or { items: [...] }
          var items = [];
          if (data && data.items) {
            items = data.items;
          } else if (data && data.id) {
            items = [data];
          }

          items.forEach(function (item) {
            var productId = item.product_id;
            var ctx = window.FreshGTM.getItemListContext(productId) || {};
            var listId = ctx.item_list_id || '';
            var listName = ctx.item_list_name || '';
            var price = (item.final_price || item.price || 0) / 100;

            var gtmItem = {
              item_id: String(productId),
              item_name: item.product_title || item.title || '',
              item_brand: item.vendor || '',
              item_variant: item.variant_title || '',
              price: price,
              quantity: item.quantity || 1,
              index: 0,
              item_list_id: listId,
              item_list_name: listName
            };

            var categories = window.FreshGTM.parseCategories(item.product_type || '');
            for (var key in categories) {
              if (categories.hasOwnProperty(key)) gtmItem[key] = categories[key];
            }

            window.FreshGTM.pushEvent({
              event: 'add_to_cart',
              ecommerce: {
                currency: 'TRY',
                value: price * (item.quantity || 1),
                items: [gtmItem]
              }
            });
          });
        } catch (e) {}
      }).catch(function () {});
      return response;
    });
  };
})();

// ─── remove_from_cart: intercept /cart/change.js ─────────────────────────────
(function () {
  var _prev = window.fetch;
  window.fetch = function () {
    var args = Array.prototype.slice.call(arguments);
    var url = args[0];
    var options = args[1] || {};
    var urlStr = (typeof url === 'string') ? url : (url && url.url ? url.url : '');

    var isCartChange = urlStr && /\/cart\/change(\.js)?(\?|$)/.test(urlStr) && (options.method || 'GET').toUpperCase() === 'POST';

    if (!isCartChange) {
      return _prev.apply(window, args);
    }

    // Read line + quantity from body BEFORE the response (DOM still has the item)
    var line = null;
    var newQty = null;
    try {
      var bodyData = JSON.parse(options.body);
      line = parseInt(bodyData.line, 10);
      newQty = parseInt(bodyData.quantity, 10);
    } catch (e) {}

    if (line !== null && newQty !== null && !isNaN(line) && !isNaN(newQty)) {
      var cartItem = document.getElementById('CartDrawer-Item-' + line) ||
                     document.getElementById('CartItem-' + line);
      if (cartItem) {
        var currentQty = parseInt(cartItem.dataset.quantity || '0', 10);
        var qtyDiff = newQty - currentQty;

        if (qtyDiff !== 0) {
          var productId = cartItem.dataset.productId || '';
          var ctx = window.FreshGTM.getItemListContext(productId) || {};
          var price = parseFloat(cartItem.dataset.price || '0');
          var absQty = Math.abs(qtyDiff);

          var gtmItem = {
            item_id: String(productId),
            item_name: cartItem.dataset.productTitle || '',
            item_brand: cartItem.dataset.vendor || '',
            item_variant: cartItem.dataset.variantTitle || '',
            price: price,
            quantity: absQty,
            index: 0,
            item_list_id: ctx.item_list_id || '',
            item_list_name: ctx.item_list_name || ''
          };

          var categories = window.FreshGTM.parseCategories(cartItem.dataset.productType || '');
          for (var key in categories) {
            if (categories.hasOwnProperty(key)) gtmItem[key] = categories[key];
          }

          var eventName = qtyDiff > 0 ? 'add_to_cart' : 'remove_from_cart';
          window.FreshGTM.pushEvent({
            event: eventName,
            ecommerce: {
              currency: 'TRY',
              value: price * absQty,
              items: [gtmItem]
            }
          });
        }
      }
    }

    return _prev.apply(window, args);
  };
})();

// ─── remove_from_cart: intercept /cart/clear.js (clear entire cart) ───────────
(function () {
  var _prev = window.fetch;
  window.fetch = function () {
    var args = Array.prototype.slice.call(arguments);
    var url = args[0];
    var options = args[1] || {};
    var urlStr = (typeof url === 'string') ? url : (url && url.url ? url.url : '');

    var isCartClear = urlStr && /\/cart\/clear(\.js)?(\?|$)/.test(urlStr) && (options.method || 'GET').toUpperCase() === 'POST';

    if (!isCartClear) {
      return _prev.apply(window, args);
    }

    // Collect all cart items from the DOM BEFORE the clear happens
    var items = [];
    var value = 0;
    var cartScope = document.querySelector('cart-drawer') || document.getElementById('main-cart') || document;
    cartScope.querySelectorAll('cart-item[data-cart-item]').forEach(function (cartItem, cartIndex) {
      try {
        var productId = cartItem.dataset.productId || '';
        var price = parseFloat(cartItem.dataset.price || '0');
        var qty = parseInt(cartItem.dataset.quantity || '1', 10);
        var ctx = window.FreshGTM.getItemListContext(productId) || {};

        var gtmItem = {
          item_id: String(productId),
          item_name: cartItem.dataset.productTitle || '',
          item_brand: cartItem.dataset.vendor || '',
          item_variant: cartItem.dataset.variantTitle || '',
          price: price,
          quantity: qty,
          index: cartIndex,
          item_list_id: ctx.item_list_id || '',
          item_list_name: ctx.item_list_name || ''
        };

        var categories = window.FreshGTM.parseCategories(cartItem.dataset.productType || '');
        for (var key in categories) {
          if (categories.hasOwnProperty(key)) gtmItem[key] = categories[key];
        }
        items.push(gtmItem);
        value += price * qty;
      } catch (e) {}
    });

    if (items.length > 0) {
      window.FreshGTM.pushEvent({
        event: 'remove_from_cart',
        ecommerce: {
          currency: 'TRY',
          value: Math.round(value * 100) / 100,
          items: items
        }
      });
    }

    return _prev.apply(window, args);
  };
})();

// ─── view_item_list: global observer for all [data-gtm-list-id] containers ────
document.addEventListener('DOMContentLoaded', function () {
  if (!window.FreshGTM) return;

  var initializedContainers = new WeakSet();

  function initContainer(container) {
    if (initializedContainers.has(container)) return;
    initializedContainers.add(container);

    var listId = String(container.dataset.gtmListId || '');
    var listName = container.dataset.gtmListName || '';
    var startIndex = parseInt(container.dataset.gtmStartIndex || '0', 10);
    var pendingItems = [];
    var fireTimer = null;
    var allCards = Array.from(container.querySelectorAll('product-card'));

    function buildItem(card) {
      var scriptEl = card.querySelector('script[data-gtm-product]');
      if (!scriptEl) return null;
      try {
        var data = JSON.parse(scriptEl.textContent);
        allCards = Array.from(container.querySelectorAll('product-card'));
        var domIndex = allCards.indexOf(card);
        var item = {
          item_id: String(data.item_id),
          item_name: data.item_name,
          item_brand: data.item_brand,
          item_variant: data.item_variant,
          price: data.price,
          quantity: 1,
          index: startIndex + (domIndex === -1 ? 0 : domIndex),
          item_list_id: listId,
          item_list_name: listName
        };
        var categories = window.FreshGTM.parseCategories(data.item_type);
        for (var key in categories) {
          if (categories.hasOwnProperty(key)) item[key] = categories[key];
        }
        window.FreshGTM.setItemListContext(data.item_id, listId, listName);
        return item;
      } catch (e) { return null; }
    }

    function fireViewItemList() {
      if (pendingItems.length === 0) return;
      var items = pendingItems.splice(0);
      window.FreshGTM.pushEvent({
        event: 'view_item_list',
        ecommerce: {
          currency: 'TRY',
          item_list_id: listId,
          item_list_name: listName,
          items: items
        }
      });
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target);
        var item = buildItem(entry.target);
        if (item) {
          pendingItems.push(item);
          clearTimeout(fireTimer);
          fireTimer = setTimeout(fireViewItemList, 300);
        }
      });
    }, { threshold: 0.1 });

    allCards.forEach(function (card) { observer.observe(card); });

    // Infinite scroll / dynamic cards added inside this container
    var mutObs = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.tagName === 'PRODUCT-CARD') {
            observer.observe(node);
          } else if (node.querySelectorAll) {
            node.querySelectorAll('product-card').forEach(function (card) {
              observer.observe(card);
            });
          }
        });
      });
    });
    mutObs.observe(container, { childList: true, subtree: true });
  }

  // Init all containers already in the DOM
  document.querySelectorAll('[data-gtm-list-id]').forEach(initContainer);

  // Watch for containers injected later (cart drawer, quick-view, ajax sections)
  new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.dataset && node.dataset.gtmListId) {
          initContainer(node);
        }
        if (node.querySelectorAll) {
          node.querySelectorAll('[data-gtm-list-id]').forEach(initContainer);
        }
      });
    });
  }).observe(document.body, { childList: true, subtree: true });
});

// ─── select_item: global delegated handler ───────────────────────────────────
document.addEventListener('click', function (e) {
  var link = e.target.closest('a[href]');
  if (!link) return;

  var card = link.closest('product-card');
  if (!card) return;

  var scriptEl = card.querySelector('script[data-gtm-product]');
  if (!scriptEl) return;

  try {
    var data = JSON.parse(scriptEl.textContent);

    // 1. Try nearest ancestor with GTM list attributes
    var container = card.closest('[data-gtm-list-id]');
    var listId = '';
    var listName = '';
    var startIndex = 0;

    if (container) {
      listId = container.dataset.gtmListId || '';
      listName = container.dataset.gtmListName || '';
      startIndex = parseInt(container.dataset.gtmStartIndex || '0', 10);
    }

    // 2. Fall back to localStorage (set during view_item_list)
    if (!listId) {
      var ctx = window.FreshGTM.getItemListContext(data.item_id);
      if (ctx) {
        listId = ctx.item_list_id;
        listName = ctx.item_list_name;
      }
    }

    // Calculate 0-based index within the container
    var allCards = container ? Array.from(container.querySelectorAll('product-card')) : [];
    var domIndex = allCards.indexOf(card);
    if (domIndex === -1) domIndex = 0;

    var item = {
      item_id: String(data.item_id),
      item_name: data.item_name,
      item_brand: data.item_brand,
      item_variant: data.item_variant,
      price: data.price,
      quantity: 1,
      index: startIndex + domIndex,
      item_list_id: listId,
      item_list_name: listName
    };
    var categories = window.FreshGTM.parseCategories(data.item_type);
    for (var key in categories) {
      if (categories.hasOwnProperty(key)) item[key] = categories[key];
    }

    window.FreshGTM.pushEvent({
      event: 'select_item',
      ecommerce: {
        item_list_id: listId,
        item_list_name: listName,
        items: [item]
      }
    });
  } catch (err) {}
});

// ─── add_to_wishlist: delegated handler for .holly-wishlist-button ────────────
// useCapture:true so this fires before the inline onclick toggles data-favorite
document.addEventListener('click', function (e) {
  var btn = e.target.closest('.holly-wishlist-button');
  if (!btn) return;

  // data-favorite is the state BEFORE the click toggles it — "false" means adding
  if (btn.dataset.favorite !== 'false') return;

  try {
    var productId = btn.dataset.product_id || '';
    var price, itemName, itemBrand, itemType;

    // 1. Try product-card (list pages / quick-view)
    var card = btn.closest('product-card');
    if (card) {
      var scriptEl = card.querySelector('script[data-gtm-product]');
      if (scriptEl) {
        var d = JSON.parse(scriptEl.textContent);
        price = d.price;
        itemName = d.item_name;
        itemBrand = d.item_brand;
        itemType = d.item_type;
      }
    }

    // 2. Try cart-item (cart drawer / cart page)
    if (!itemName) {
      var cartItem = btn.closest('cart-item');
      if (cartItem) {
        price = parseFloat(cartItem.dataset.price || '0');
        itemName = cartItem.dataset.productTitle || '';
        itemBrand = cartItem.dataset.vendor || '';
        itemType = cartItem.dataset.productType || '';
        productId = productId || cartItem.dataset.productId || '';
      }
    }

    // 3. Fall back to data attributes on the button itself (PDP)
    if (!itemName) {
      price = parseFloat(btn.dataset.gtmPrice || '0');
      itemName = btn.dataset.gtmItemName || '';
      itemBrand = btn.dataset.gtmItemBrand || '';
      itemType = btn.dataset.gtmItemType || '';
    }

    var ctx = window.FreshGTM.getItemListContext(productId) || {};

    var gtmItem = {
      item_id: String(productId),
      item_name: itemName,
      item_brand: itemBrand,
      item_variant: btn.dataset.variant_id || '',
      price: price,
      quantity: 1,
      index: 0,
      item_list_id: ctx.item_list_id || '',
      item_list_name: ctx.item_list_name || ''
    };

    var categories = window.FreshGTM.parseCategories(itemType);
    for (var key in categories) {
      if (categories.hasOwnProperty(key)) gtmItem[key] = categories[key];
    }

    window.FreshGTM.pushEvent({
      event: 'add_to_wishlist',
      ecommerce: {
        currency: 'TRY',
        value: price,
        items: [gtmItem]
      }
    });
  } catch (err) {}
}, true); // capture phase — fires before inline onclick toggles data-favorite

// ─── view_cart ────────────────────────────────────────────────────────────────
(function () {
  function buildCartItems(scope) {
    var root = scope || document;
    var items = [];
    root.querySelectorAll('cart-item[data-cart-item]').forEach(function (cartItem, cartIndex) {
      try {
        var productId = cartItem.dataset.productId || '';
        var price = parseFloat(cartItem.dataset.price || '0');
        var qty = parseInt(cartItem.dataset.quantity || '1', 10);
        var ctx = window.FreshGTM.getItemListContext(productId) || {};

        var gtmItem = {
          item_id: String(productId),
          item_name: cartItem.dataset.productTitle || '',
          item_brand: cartItem.dataset.vendor || '',
          item_variant: cartItem.dataset.variantTitle || '',
          price: price,
          quantity: qty,
          index: cartIndex,
          item_list_id: ctx.item_list_id || '',
          item_list_name: ctx.item_list_name || ''
        };

        var categories = window.FreshGTM.parseCategories(cartItem.dataset.productType || '');
        for (var key in categories) {
          if (categories.hasOwnProperty(key)) gtmItem[key] = categories[key];
        }
        items.push(gtmItem);
      } catch (e) {}
    });
    return items;
  }

  function fireViewCart(scope) {
    var items = buildCartItems(scope);
    if (items.length === 0) return;
    var value = items.reduce(function (sum, item) {
      return sum + (item.price * item.quantity);
    }, 0);
    window.FreshGTM.pushEvent({
      event: 'view_cart',
      ecommerce: {
        currency: 'TRY',
        value: Math.round(value * 100) / 100,
        items: items
      }
    });
  }

  // Cart page: fire once on load, scoped to the main cart container
  document.addEventListener('DOMContentLoaded', function () {
    var mainCart = document.getElementById('main-cart') || document.querySelector('.main-cart-items');
    if (mainCart) {
      fireViewCart(mainCart);
    }
  });
})();

// ─── begin_checkout ───────────────────────────────────────────────────────────
document.addEventListener('click', function (e) {
  if (!e.target.closest('[name="checkout"]')) return;
  try {
    var items = [];
    var cartScope = document.getElementById('main-cart') || document;
    cartScope.querySelectorAll('cart-item[data-cart-item]').forEach(function (cartItem, cartIndex) {
      var productId = cartItem.dataset.productId || '';
      var price = parseFloat(cartItem.dataset.price || '0');
      var qty = parseInt(cartItem.dataset.quantity || '1', 10);
      var ctx = window.FreshGTM.getItemListContext(productId) || {};
      var gtmItem = {
        item_id: String(productId),
        item_name: cartItem.dataset.productTitle || '',
        item_brand: cartItem.dataset.vendor || '',
        item_variant: cartItem.dataset.variantTitle || '',
        price: price,
        quantity: qty,
        index: cartIndex,
        item_list_id: ctx.item_list_id || '',
        item_list_name: ctx.item_list_name || ''
      };
      var cats = window.FreshGTM.parseCategories(cartItem.dataset.productType || '');
      for (var k in cats) { if (cats.hasOwnProperty(k)) gtmItem[k] = cats[k]; }
      items.push(gtmItem);
    });
    if (items.length === 0) return;
    var value = items.reduce(function (sum, item) { return sum + (item.price * item.quantity); }, 0);

    // Read applied discount/coupon codes from the cart
    var couponCodes = [];
    cartScope.querySelectorAll('.cart-discount-code-applied').forEach(function (el) {
      var codeEl = el.querySelector('.hp\\:uppercase');
      var code = codeEl ? (codeEl.textContent || '').trim() : '';
      if (code) couponCodes.push(code);
    });
    var coupon = couponCodes.join(',');

    window.FreshGTM.pushEvent({
      event: 'begin_checkout',
      ecommerce: {
        currency: 'TRY',
        coupon: coupon,
        value: Math.round(value * 100) / 100,
        items: items
      }
    });
  } catch (err) {}
});

// ─── view_promotion / select_promotion ───────────────────────────────────────
(function () {
  var firedPromos = {};   // promoId -> true, prevents double-firing per pageview
  var watchedSwipers = new WeakSet();
  var observedPromos = new WeakSet();

  function getCreativeName(el) {
    var img = el.querySelector('img[alt]');
    var alt = img && img.getAttribute('alt');
    return (alt && alt.trim()) ? alt.trim() : (el.dataset.gtmCreativeName || '');
  }

  function buildPromoItem(el) {
    return {
      promotion_id: el.dataset.gtmPromoId || '',
      promotion_name: el.dataset.gtmPromoName || '',
      creative_name: getCreativeName(el),
      creative_slot: el.dataset.gtmCreativeSlot || ''
    };
  }

  function firePromo(el) {
    var id = el.dataset.gtmPromoId;
    if (!id || firedPromos[id]) return;
    firedPromos[id] = true;
    window.FreshGTM.pushEvent({
      event: 'view_promotion',
      ecommerce: {
        creative_name: getCreativeName(el),
        creative_slot: el.dataset.gtmCreativeSlot || '',
        promotion_id: id,
        promotion_name: el.dataset.gtmPromoName || '',
        items: [buildPromoItem(el)]
      }
    });
  }

  function isInViewport(el) {
    var r = el.getBoundingClientRect();
    return r.width > 0 && r.height > 0 && r.top < window.innerHeight && r.bottom > 0;
  }

  // Swiper slides: observe the wrapper for active-class changes
  function watchSwiperWrapper(wrapper) {
    if (watchedSwipers.has(wrapper)) return;
    watchedSwipers.add(wrapper);

    // Fire for whichever slide is active when the swiper first enters the viewport
    var wrapperObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        if (entry.intersectionRect.width === 0 || entry.intersectionRect.height === 0) return;
        var active = wrapper.querySelector('.swiper-slide-active[data-gtm-promo-id]');
        if (active) firePromo(active);
      });
    }, { threshold: 0.5 });
    wrapperObserver.observe(wrapper);

    // Fire for each subsequent active slide change (user navigates the slider)
    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.attributeName !== 'class') return;
        var target = mutation.target;
        if (target.classList.contains('swiper-slide-active') && target.dataset.gtmPromoId) {
          if (isInViewport(wrapper)) firePromo(target);
        }
      });
    }).observe(wrapper, { attributes: true, attributeFilter: ['class'], subtree: true });
  }

  // Non-swiper promos: standard IntersectionObserver
  var promoObserver = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      if (entry.intersectionRect.width === 0 || entry.intersectionRect.height === 0) return;
      promoObserver.unobserve(entry.target);
      firePromo(entry.target);
    });
  }, { threshold: 0.5 });

  function handlePromoEl(el) {
    if (el.classList.contains('swiper-slide')) {
      var wrapper = el.closest('.swiper-wrapper');
      if (wrapper) watchSwiperWrapper(wrapper);
    } else {
      if (observedPromos.has(el)) return;
      observedPromos.add(el);
      promoObserver.observe(el);
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-gtm-promo-id]').forEach(handlePromoEl);

    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.dataset && node.dataset.gtmPromoId) handlePromoEl(node);
          if (node.querySelectorAll) {
            node.querySelectorAll('[data-gtm-promo-id]').forEach(handlePromoEl);
          }
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  });

  // select_promotion: click on any link inside a promo element
  document.addEventListener('click', function (e) {
    var link = e.target.closest('a[href]');
    if (!link) return;
    var promo = link.closest('[data-gtm-promo-id]');
    if (!promo) return;
    window.FreshGTM.pushEvent({
      event: 'select_promotion',
      ecommerce: {
        creative_name: getCreativeName(promo),
        creative_slot: promo.dataset.gtmCreativeSlot || '',
        promotion_id: promo.dataset.gtmPromoId || '',
        promotion_name: promo.dataset.gtmPromoName || '',
        items: [buildPromoItem(promo)]
      }
    });
  });
})();

// ─── add_to_wishlist: cart remove modal "remove & add to favorites" ───────────
document.addEventListener('click', function (e) {
  var btn = e.target.closest('.js-remove-and-favorite');
  if (!btn) return;

  try {
    // The modal's confirm button carries data-item-index (0-based) set when modal opened
    var modal = document.getElementById('CartRemoveModal');
    if (!modal) return;
    var confirmBtn = modal.querySelector('.js-remove-confirm');
    if (!confirmBtn) return;
    var itemIndex = parseInt(confirmBtn.dataset.itemIndex, 10);
    if (isNaN(itemIndex)) return;
    var lineNumber = itemIndex + 1; // cart-item IDs are 1-based

    var cartItem = document.getElementById('CartDrawer-Item-' + lineNumber) ||
                   document.getElementById('CartItem-' + lineNumber);
    if (!cartItem) return;

    var productId = cartItem.dataset.productId || '';
    var price = parseFloat(cartItem.dataset.price || '0');
    var ctx = window.FreshGTM.getItemListContext(productId) || {};

    var gtmItem = {
      item_id: String(productId),
      item_name: cartItem.dataset.productTitle || '',
      item_brand: cartItem.dataset.vendor || '',
      item_variant: cartItem.dataset.variantTitle || '',
      price: price,
      quantity: 1,
      index: 0,
      item_list_id: ctx.item_list_id || '',
      item_list_name: ctx.item_list_name || ''
    };

    var categories = window.FreshGTM.parseCategories(cartItem.dataset.productType || '');
    for (var key in categories) {
      if (categories.hasOwnProperty(key)) gtmItem[key] = categories[key];
    }

    window.FreshGTM.pushEvent({
      event: 'add_to_wishlist',
      ecommerce: {
        currency: 'TRY',
        value: price,
        items: [gtmItem]
      }
    });
  } catch (err) {}
});
